import React from 'react';
import config from '../../../config';
import styles from './styles.scss';


const AppFooter = () => {
  const today = new Date();
  const fullYear = today.getFullYear();

  return (
    <footer className={styles.footer}>
      <div className='container'>
        Copyright 2018 - {fullYear} Spruce Environmental Technologies, Inc. v.{config.version}
      </div>
    </footer>
  );
};

export default AppFooter;


// WEBPACK FOOTER //
// src/components/layout/AppFooter/index.jsx